import gql from 'graphql-tag';

const GET_CONTRACT_TEMPLATE = gql`
  query getContractTemplate($input: ContractIdentifierInput!) {
    getContractTemplate(input: $input) {
      contract {
        contractId
        name
        description
        contractType
        updatedTime
        billableContract {
          cumulatedQuantity
          billableSiteType
          contractId
          frequencyType
          provisionRule {
            provisionRuleId
          }
          chargeItem {
            itemId
            name
            description
            category {
              categoryId
              name
            }
            itemType
            offerAsWorklogItem
            status
            taxable
            salesTax {
              taxId
            }
            sellingPrice {
              model
              details {
                value
                afterHoursValue
              }
            }
            serviceTypeItem {
              itemId
              offeringType
              bundledItems {
                name
                itemId
                itemType
              }
              hourlyServiceTypeItem {
                itemId
                roundUpValue
              }
              redeemableServiceBundle {
                itemId
                applicableType
                applicableHours
                redeemableQuantity
              }
            }
          }
          quantityCalculationType
          sellingPriceCalculationType
          sellingPrice {
            model
            details {
              value
              afterHoursValue
            }
          }
          sellingPriceOverridden
          discountRate
          generateInvoice
          paymentTerm {
            paymentTermId
            paymentTermName
          }
          changes {
            changeId
            effectiveDate
            endDate
            quantity
            quantityChangeOperation
            generateInvoice
            prorated
          }
          project {
            projectId
          }
          includedItemList {
            contractId
            sellingPrice {
              model
              details {
                value
                afterHoursValue
              }
            }
            provisionRule {
              provisionRuleId
              name
              ruleEntityType
              ruleCondition
              items {
                itemId
                name
              }
              parentRule {
                provisionRuleId
              }
              siteQuantities {
                site {
                  id
                }
                quantity
              }
              defaultRule
            }
            serviceCatalogItem {
              itemId
              name
              description
              category {
                categoryId
                name
              }
              itemType
              offerAsWorklogItem
              status
              taxable
              salesTax {
                taxId
              }
              sellingPrice {
                model
                details {
                  value
                  afterHoursValue
                }
              }
              costPrice {
                model
                details {
                  value
                  afterHoursValue
                }
              }
              serviceTypeItem {
                itemId
                offeringType
                bundledItems {
                  name
                  itemId
                  itemType
                  sellingPrice {
                    model
                    details {
                      value
                      afterHoursValue
                    }
                  }
                  costPrice {
                    model
                    details {
                      value
                      afterHoursValue
                    }
                  }
                }
                hourlyServiceTypeItem {
                  itemId
                  roundUpValue
                  defaultItem
                }
                redeemableServiceBundle {
                  itemId
                  applicableType
                  applicableHours
                  redeemableQuantity
                }
              }
            }
          }
          recurringContract {
            contractId
            recurringMode
            frequencyDurationUnit
            frequencyInterval
            billingOffset
            nextBillDate
          }
          redeemableContract {
            contractId
            applicableType
            applicableHours
            carryForwardRemainingQuantity
          }
          perpetualContract {
            contractId
            autoRenew
          }
        }
        contractApplication {
          contractId
          contractOrder
          applicationRuleCondition
          contractSLA {
            id
            sla {
              id
              name
            }
            slaOrder
          }
          autoApproveItems {
            itemId
            name
            description
          }
          blacklistedItems {
            itemId
            name
            description
          }
          overrides {
            overrideId
            overrideCategory
            conditionalPricing {
              overrideId
              name
              ticketRuleCondition
            }
            overrideItems {
              overrideItemId
              serviceCatalogItem {
                itemId
                name
                description
                itemType
                offerAsWorklogItem
                status
                serviceTypeItem {
                  itemId
                  offeringType
                }
                sellingPrice {
                  model
                  details {
                    value
                    afterHoursValue
                  }
                }
                # costPrice {
                #   model
                #   details {
                #     value
                #     afterHoursValue
                #   }
                # }
              }
              overrideValue {
                model
                details {
                  value
                  afterHoursValue
                }
              }
              overrideType
              overrideByMetric
            }
          }
        }
      }
    }
  }
`;

const GET_CONTRACT_TEMPLATES = gql`
  query getContractTemplates($input: BillingTemplateIdentifierInput!) {
    getContractTemplates(input: $input) {
      contract {
        contractId
        name
        description
        contractType
        updatedTime
        billableContract {
          cumulatedQuantity
          contractId
          chargeItem {
            itemId
            name
            description
          }
          quantityCalculationType
          sellingPriceCalculationType
          sellingPrice {
            model
            details {
              value
              afterHoursValue
            }
          }
          sellingPriceOverridden
          discountRate
          generateInvoice
          frequencyType
          paymentTerm {
            paymentTermId
            paymentTermName
          }
          includedItems {
            itemId
            name
          }
          billableSiteType
          sites {
            id
            name
          }
          recurringContract {
            contractId
            recurringMode
            frequencyDurationUnit
            frequencyInterval
            billingOffset
            nextBillDate
          }
          redeemableContract {
            contractId
            applicableType
            applicableHours
            carryForwardRemainingQuantity
          }
          perpetualContract {
            contractId
            autoRenew
          }
          changes {
            changeId
            effectiveDate
            endDate
            quantity
            quantityChangeOperation
            generateInvoice
            prorated
          }
          project {
            projectId
          }
        }
        contractApplication {
          contractId
          contractOrder
          applicationRuleCondition
          contractSLA {
            id
            sla {
              id
              name
            }
            slaOrder
          }
          autoApproveItems {
            itemId
            name
            description
          }
          blacklistedItems {
            itemId
            name
            description
          }
          overrides {
            overrideId
            overrideCategory
            conditionalPricing {
              overrideId
              name
              description
              ticketRuleCondition
            }
            overrideItems {
              overrideItemId
              serviceCatalogItem {
                itemId
                name
              }
              overrideValue {
                model
                details {
                  value
                  afterHoursValue
                }
              }
              overrideType
              overrideItemId
              overrideByMetric
              serviceCatalogItem {
                itemId
                name
              }
            }
          }
          autoApproveItems {
            itemId
            name
          }
          blacklistedItems {
            itemId
            name
          }
          contractSLA {
            id
            slaOrder
          }
        }
      }
    }
  }
`;

export { GET_CONTRACT_TEMPLATE, GET_CONTRACT_TEMPLATES };
